import cx from 'classnames';
import { forwardRef } from 'react';

import { Icon } from '../../icons';

export type CardButtonSize = 'sm' | 'lg';

const CARD_BUTTON_SIZE_CLASSES: Record<CardButtonSize, string> = {
  sm: cx('tw-rounded-[16px]', 'tw-px-12', 'tw-py-8', 'tw-gap-12'),
  lg: cx('tw-rounded-[24px]', 'tw-pl-16', 'tw-pr-8', 'tw-py-12', 'tw-gap-8'),
};

export interface CardButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Controls border-radius and padding preset. Default: 'lg' */
  size?: CardButtonSize;
  /** Shows a trailing chevronRight icon. Default: true */
  showChevron?: boolean;
}

export const CardButton = forwardRef<HTMLButtonElement, CardButtonProps>(
  (
    {
      type = 'button',
      size = 'lg',
      showChevron = true,
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <button
        type={type}
        className={cx(
          className,
          CARD_BUTTON_SIZE_CLASSES[size],
          'tw-bg-fill-primary',
          'tw-flex',
          'tw-items-center',
          'tw-overflow-clip',
          'tw-text-left',
          'enabled:active:tw-brightness-95',
          'enabled:hover:tw-brightness-[1.02]',
          'disabled:tw-cursor-not-allowed',
          'disabled:tw-opacity-50',
          'tw-select-none',
          'tw-cursor-pointer',
          'tw-transition-[filter]',
          'tw-duration-100',
        )}
        {...rest}
        ref={ref}
      >
        {children}
        {showChevron && (
          <Icon
            kind="chevronRight"
            className={cx(
              'tw-shrink-0',
              'tw-icon-28',
              'tw-text-label-tertiary',
            )}
          />
        )}
      </button>
    );
  },
);
